import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full h-[400px] py-10 bg-cover bg-no-repeat bg-center bg-[url('https://images.pexels.com/photos/14700386/pexels-photo-14700386.jpeg')]" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-center pt-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "font-bold text-8xl" }, "Pexelry"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-3xl mt-6" }, "pic it")
], -1)
const _hoisted_3 = { class: "text-center my-6" }
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "py-2.5 px-4 bg-indigo-100 font-bold"
  }, " Search ")
], -1)
const _hoisted_7 = { class: "w-4/5 mx-auto grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-8 py-10" }

import Card from "@/components/Card.vue";
import { ref, onMounted, computed } from "vue";
import { useRootStore } from "@/store";
import { toastSuccess } from "@/plugins/toast";


export default /*#__PURE__*/_defineComponent({
  __name: 'Search',
  setup(__props) {

const store = useRootStore();
const searchinput = ref(``);
const photos = computed(() => store.$state.photos);

onMounted(async () => {
  await store.fetchPhotos("cities");
});

// methods

function getSearch() {
  if (!searchinput.value) {
    toastSuccess(`  Please enter search term`);
    return;
  }
  store.fetchPhotos(searchinput.value);
  searchinput.value = ``;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(getSearch, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "py-2 px-8 border focus:outline-none",
                placeholder: "Search photos here ...",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchinput).value = $event))
              }, null, 512), [
                [_vModelText, searchinput.value]
              ])
            ]),
            _hoisted_6
          ])
        ], 40, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(photos.value, (photo) => {
        return (_openBlock(), _createBlock(Card, {
          key: photo.id,
          name: photo.photographer,
          photographer_url: photo.photographer_url,
          attrib: photo.photographer_url,
          img: photo.src.medium,
          img_large: photo.src.large2x,
          imgcap: photo.src.portrait,
          id: photo.id
        }, null, 8, ["name", "photographer_url", "attrib", "img", "img_large", "imgcap", "id"]))
      }), 128))
    ])
  ]))
}
}

})